import { DisaggregatedMetric, MetricPanelProps } from "../../services/types";
import { getIndexMetricData, getSortedMetrics, getSvgrMap } from "../../utils/dashboardUtils";
import RoadQualityCharts from "../charts/gauge/RoadQualityCharts";
import IndexBanner from "../IndexBanner";
import MetricCard from "../MetricCard";

const AccessibilityMetrics = ({ indicators, metadata, categorizedData, tab, geoDetails, geoTag, selectionActive }: MetricPanelProps) => {   
    const sortedMetrics = getSortedMetrics(tab, categorizedData);
    console.log("accessibility data:", sortedMetrics);

    let metricsForTab = indicators; // Get metrics for the current tab

    // Find the current tab index metric data and id
    const { indexMetricId, indexMetricData } = getIndexMetricData(tab, metadata, indicators);

    // Exclude the index metric from the list of metrics
    if (indexMetricId) {
        metricsForTab = metricsForTab.filter((metric) => metric.id !== indexMetricId);
    }

    if (!metricsForTab || metricsForTab.length === 0) {
        return <div className="flex items-center justify-center text-color-cai-dashboard">No metrics available for {tab}.</div>;
    }

    // Define metrics for order
    const a: DisaggregatedMetric[] = sortedMetrics[0];
    const a2: DisaggregatedMetric[] = sortedMetrics[1];
    const a3: DisaggregatedMetric[] = sortedMetrics[2];
    const pci = indicators.find(i => i.id == 44);

    return (
        <>
            <div className="mb-2">
                <IndexBanner
                    key={indexMetricId}
                    metric={indexMetricData}
                    svg={undefined}
                    disaggData={indicators}
                    geoDetails={geoDetails}
                    geoTag={geoTag}
                    selectionActive={selectionActive}
                />
            </div>

            <p className="text-[10px] text-port-text mx-4">
            Activate the <span aria-hidden="true">🛈</span> <strong>button</strong> to expand additional information about a metric.
            </p>
            <p className="text-port-text mx-4 text-[10px]">Data updates published March 30, 2026.</p>

            <div className="mx-auto px-4 pb-8 pt-4">
                <div className="grid grid-cols-2 gap-4">
                    <h2 className="text-sm font-semibold text-port-text col-span-2">Mobility & Access</h2>
                    {a.map(metric => (
                        <MetricCard
                            key={metric.id}
                            metric={metric}
                            width="w-full"
                            svg={getSvgrMap(metric.id)}
                            disaggData={indicators}
                            geoDetails={geoDetails}
                            geoTag={geoTag}
                            selectionActive={selectionActive}
                        />
                    ))}

                    <div className="w-full col-span-2">
                        <RoadQualityCharts 
                            metric={pci}
                            disaggData={indicators}
                            geoDetails={geoDetails}
                            geoTag={geoTag}
                            selectionActive
                        />
                    </div>

                    <h2 className="text-sm font-semibold text-port-text col-span-2">Civic & Digital Access</h2>
                    {a2.map(metric => (
                        <MetricCard
                            key={metric.id}
                            metric={metric}
                            width="w-full"
                            svg={getSvgrMap(metric.id)}
                            disaggData={indicators}
                            geoDetails={geoDetails}
                            geoTag={geoTag}
                            selectionActive={selectionActive}
                        />
                    ))}

                    <h2 className="text-sm font-semibold text-port-text col-span-2">Parks & Community</h2>
                    {a3.map(metric => (
                        <MetricCard
                            key={metric.id}
                            metric={metric}
                            width="w-full"
                            svg={getSvgrMap(metric.id)}
                            disaggData={indicators}
                            geoDetails={geoDetails}
                            geoTag={geoTag}
                            selectionActive={selectionActive}
                        />
                    ))}
                </div>
            </div>
        </>
    );
}

export default AccessibilityMetrics;